export const FINANCE_EMBEDDED_NOTEPAD_SLOTS = [
  { key: 'track_balances_note_id', label: 'Track balances' },
  { key: 'track_investments_note_id', label: 'Track investments' },
];

export const FINANCE_DEFAULT_EMBEDDED_NOTEPAD_LINKS = {
  track_balances_note_id: null,
  track_investments_note_id: null,
};
